import { PluTypes, computeCompositeModifierPlu, getVendorConfig } from '../vendor-config';

import { IItemOptionModifierPluIsAvailable } from './types';

import { pluIsAvailable } from '.';

export const itemOptionModifierPluIsAvailable = ({
  item,
  itemOptionModifier,
  vendor,
  prices
}: IItemOptionModifierPluIsAvailable): boolean => {
  const vendorConfig = getVendorConfig(itemOptionModifier, vendor);

  if (vendorConfig && vendorConfig.pluType === PluTypes.IGNORE) {
    return true;
  }

  const compositePlu = computeCompositeModifierPlu({ item, modifier: itemOptionModifier, vendor });

  return pluIsAvailable(compositePlu, prices);
};
